import { humanize } from "web/services/inflector"

export default function useCompareDataValues({
  subjectType,
  topic,
  data,
  averages,
  variances,
  variance_percentages,
  comparisonColumns,
  view,
  hasAverages,
  hasVariances,
  hasVariancePercentages,
}) {
  const compareData = []
  const hasTopic = !!topic
  const defaultColumnName = hasTopic ? topic.label : humanize(subjectType)
  const { comparison } = view
  const { reference_subject_id, selected_subject_ids, show_all } = comparison

  data.forEach((datum, index) => {
    const columnName =
      !hasTopic && "name" in datum
        ? datum.name
        : `${defaultColumnName} ${index + 1}`

    compareData.push({ ...datum, columnName })
  })

  if (hasAverages) {
    compareData.push({
      columnName: "averages",
      columnLabel: "Average",
      values: averages,
    })
  }
  if (hasVariances) {
    compareData.push({
      columnName: "variances",
      columnLabel: "Variance",
      values: variances,
    })
  }
  if (hasVariancePercentages) {
    compareData.push({
      columnName: "variance_percentages",
      columnLabel: "Variance %",
      values: variance_percentages,
    })
  }

  compareData.sort((a) => {
    if (a.id === reference_subject_id) {
      return -1
    }
    return 1
  })

  function filteredSelectedAndComparisonColumns() {
    return {
      compareData: compareData.filter(({ id, columnName }) => {
        return (
          selected_subject_ids.includes(id) ||
          comparisonColumns.includes(columnName)
        )
      }),
    }
  }

  if (show_all) {
    return { compareData }
  } else {
    return filteredSelectedAndComparisonColumns()
  }
}
